var _rect, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXIconMsg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 24.5,
    fill: "#000B30"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2779 19.2863C19.4009 19.1634 19.5677 19.0943 19.7416 19.0943C19.9155 19.0943 20.0823 19.1634 20.2054 19.2863L24.9916 24.0725L29.7779 19.2863C29.8379 19.2218 29.9104 19.1701 29.9909 19.1342C30.0714 19.0983 30.1583 19.079 30.2464 19.0775C30.3345 19.0759 30.422 19.0921 30.5038 19.1252C30.5855 19.1582 30.6597 19.2073 30.722 19.2696C30.7843 19.3319 30.8335 19.4061 30.8665 19.4879C30.8995 19.5696 30.9157 19.6571 30.9141 19.7452C30.9126 19.8333 30.8933 19.9202 30.8574 20.0007C30.8215 20.0812 30.7698 20.1537 30.7054 20.2138L25.9191 25L30.7054 29.7863C30.7698 29.8463 30.8215 29.9188 30.8574 29.9993C30.8933 30.0798 30.9126 30.1667 30.9141 30.2548C30.9157 30.3429 30.8995 30.4304 30.8665 30.5122C30.8335 30.5939 30.7843 30.6681 30.722 30.7304C30.6597 30.7927 30.5855 30.8419 30.5038 30.8749C30.422 30.9079 30.3345 30.9241 30.2464 30.9225C30.1583 30.921 30.0714 30.9017 29.9909 30.8658C29.9104 30.83 29.8379 30.7782 29.7779 30.7138L24.9916 25.9275L20.2054 30.7138C20.081 30.8297 19.9164 30.8928 19.7464 30.8898C19.5764 30.8868 19.4142 30.8179 19.2939 30.6977C19.1737 30.5774 19.1048 30.4152 19.1018 30.2452C19.0988 30.0752 19.1619 29.9107 19.2779 29.7863L24.0641 25L19.2779 20.2138C19.155 20.0907 19.0859 19.9239 19.0859 19.75C19.0859 19.5761 19.155 19.4093 19.2779 19.2863Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 24.5,
    stroke: "#000B30"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIconMsg);
export default __webpack_public_path__ + "static/media/XIconMsg.ebf697b427246c3c53483e9f12b90ee7.svg";
export { ForwardRef as ReactComponent };